import { Component, factory } from '../compiler';
import { loadPolyfill } from '../script/load-polyfill';

export function loadComponents(...components: any[]): void {
	const last = components[components.length - 1];
	let observeAll = false;
	if (typeof last === 'boolean') {
		observeAll = last;
		components.pop();
	}
	loadPolyfill(() => factory(components, observeAll)(document.body));
}

export function createDefaultComponent(
	component: any,
	className: string,
	observe = true
) {
	const cls = class componentClass {
		constructor(element: HTMLElement) {
			new component(element);
		}
	};

	const annotated = Component({ className, observe })(cls);

	return annotated;
}
